import { apiClient as baseApiClient } from '#/api/client.tsx';
import type { Enrollment } from '../model';

const enrollmentsApiClient = baseApiClient.create({
  baseURL: `${import.meta.env.VITE_BASE_URL}/cockpit/auto-pay`,
});

const ETC_ENROLLMENT_BASE = '/etc-auto-pay-enrollments';
const HMF_ENROLLMENT_BASE = '/highway-maintenance-fee-auto-pay-enrollments';
const HMFP_ENROLLMENT_BASE =
  '/highway-maintenance-fee-penalty-auto-pay-enrollments';
const CIP_ENROLLMENT_BASE =
  '/compulsory-insurance-penalty-auto-pay-enrollments';

type EnrollmentStateFilter = 'ACTIVE' | 'INACTIVE';

export type ListEnrollmentsParams = {
  page?: number;
  pageSize?: number;
  state?: EnrollmentStateFilter;
  isSuspended?: boolean;
  accountId?: string;
};

export type ListEnrollmentsResponse = {
  data: Enrollment[];
  extra: {
    totalElement: number;
    totalPage: number;
  };
};

const buildListEnrollments =
  (basePath: string) =>
  (params: ListEnrollmentsParams = {}) => {
    return enrollmentsApiClient
      .get<ListEnrollmentsResponse>(basePath, {
        params,
        paramsSerializer(p) {
          const cleaned = Object.fromEntries(
            Object.entries(p).filter(([, value]) => value !== undefined),
          );
          return new URLSearchParams(
            cleaned as Record<string, string>,
          ).toString();
        },
      })
      .then((res) => res.data);
  };

export const listEtcEnrollments = buildListEnrollments(ETC_ENROLLMENT_BASE);
export const listHmfEnrollments = buildListEnrollments(HMF_ENROLLMENT_BASE);
export const listHmfpEnrollments = buildListEnrollments(HMFP_ENROLLMENT_BASE);
export const listCipEnrollments = buildListEnrollments(CIP_ENROLLMENT_BASE);
